export default {
    FPDualEntryComputer: {
        datapoint: {
            name: 'FPDualEntryComputer',
            customData: function (entrySource) { return ({ entrySource: entrySource }); },
        },
    },
    FPDualEntryFilePicker: {
        datapoint: {
            name: 'FPDualEntryFilePicker',
            customData: function (entrySource) { return ({ entrySource: entrySource }); },
        },
    },
};
//# sourceMappingURL=datapoints.js.map